import { useTheme } from '../../ThemeContext';

let injected = false;

export default function Spinner({ size = 40 }) {
  const { t } = useTheme();

  if (!injected && typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = '@keyframes ls-spin { 100% { transform: rotate(360deg); } }';
    document.head.appendChild(style);
    injected = true;
  }

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      border: `${Math.max(2, Math.round(size / 10))}px solid ${t.borderStrong}`,
      borderTopColor: t.accent,
      borderRadius: '50%',
      animation: 'ls-spin 1s linear infinite',
    }} />
  );
}
